export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-500-9024e4c16d0f988f48484fe5e1dd0741.svg";